import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload';

import Utils from 'src/app/utils';

declare var bootstrap: any;
import * as _ from 'lodash-es';
import moment from 'moment';
declare var require: any;

@Component({
  selector: 'app-shiftupload',
  templateUrl: './shiftupload.component.html',
  styleUrls: ['./shiftupload.component.scss']
})
export class ShiftuploadComponent implements OnInit {

  u = Utils;

  upload_identfier = "email";

  
  uploadGroup:any = null;
  exportGroup:any = null;
  export_dates: any;
  export_loading = false;


  uploader:FileUploader;
  hasBaseDropZoneOver:boolean;
  hasAnotherDropZoneOver:boolean;
  response:string;


  upload_errors = false;

  file_error = "";
  upload_step = 1;
  upload_data = [];


  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) {



    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;

    let url = this.okService.getUrl('');
    this.uploader = new FileUploader({url: url});

    this.response = '';


  }

  ngOnInit(): void {


    this.uploadGroup = new FormGroup({
      identifier: new FormControl('pin',[Validators.required]),
      headers: new FormControl(true,[]),
    });

    this.exportGroup = new FormGroup({
      start: new FormControl('',[]),
      end: new FormControl('',[]),
      identifier: new FormControl('pin',[Validators.required]),
      worker_ids: new FormControl([],[Validators.required]),
      group_ids: new FormControl([],[Validators.required]),
    });

    this.export_dates = { startDate: moment(), endDate: moment() };

  }

  submitExport(){


        let values = this.exportGroup.value;
        //console.log(this.exportGroup.value);
        values.start = this.export_dates.startDate.format("YYYY-MM-DD")
        values.end = this.export_dates.endDate.format("YYYY-MM-DD")
        values.worker_ids = values.worker_ids.join(",");
        values.group_ids = values.group_ids.join(",");

        //console.log('dates',values);
        //this.export_loading = true;
        this.okService.download("startendshifts/export",values);

  }

  submitImport(){

  }

  continueUpload(){
    this.setupLoader();

  }

  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e:any):void {
    this.hasAnotherDropZoneOver = e;
  }

  reset(){
    this.upload_errors = false;
    this.setupLoader();
  }

  
  setupLoader(){

    let values = this.uploadGroup.value;
    //console.log(this.uploadGroup.value);
    this.upload_step = 1;

    let url = this.okService.getUrl('startendshifts/upload');
    url = url+'?identifier='+values.identifier+'&headers='+values.headers;

    //console.log(url);

    let token = "Bearer "+this.okService.session.token;
    //console.log(token);

    let headers: { name: string; value: string }[] = [];
    if (this.okService.session.cid) {
      headers.push({ name: 'cid', value: this.okService.session.cid });
    }

    this.uploader = new FileUploader({
      url: url,
      authToken: token,
      headers: headers,
      itemAlias:"upload",
      disableMultipart: false, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
      // formatDataFunctionIsAsync: true,
      // formatDataFunction: async (item:any) => {
      //   return new Promise( (resolve, reject) => {
      //     resolve({
      //       name: item._file.name,
      //       length: item._file.size,
      //       contentType: item._file.type,
      //       date: new Date()
      //     });
      //   });
      //}
    });

    this.uploader.onAfterAddingFile = (item => {
       item.withCredentials = false;
    });

    this.uploader.response.subscribe( res => {

      this.file_error = "";

      let data = JSON.parse(res);
      //console.log(data);

      if(data['error']){
        this.file_error = data['error'];
      }else{
        this.upload_step = 2;
        this.upload_data = data['shift_data'];


      }


    } );


  }


}
